// /home/labdoo/zitech-nexus/frontend/src/pages/admin/StudentProgressTracker.tsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminTrainingAPI } from '../../services/api';
import './StudentProgressTracker.css';

// SVG Icons
const Icons = {
  Student: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Enrollment: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M8 8H16M8 12H12" />
    </svg>
  ),
  Progress: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  Completed: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M8 12L11 15L16 9" />
    </svg>
  ),
  InProgress: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 6V12L16 14" />
    </svg>
  ),
  NotStarted: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  ),
  Search: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="17" y2="17" />
    </svg>
  ),
  Export: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3V15M12 15L9 12M12 15L15 12" />
      <path d="M5 17V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V17" />
    </svg>
  ),
  View: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  Check: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <path d="M20 6L9 17L4 12" />
    </svg>
  ),
  Close: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Calendar: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  Spinner: () => (
    <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="spt-spinner-svg">
      <path d="M12 2v4M12 22v-4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M22 12h-4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    </svg>
  ),
  StatusDot: () => (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="currentColor">
      <circle cx="4" cy="4" r="4" />
    </svg>
  ),
  GradCap: () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L2 7L12 12L22 7L12 2Z" />
      <path d="M2 17L12 22L22 17" />
      <path d="M2 12L12 17L22 12" />
      <line x1="12" y1="12" x2="12" y2="7" />
    </svg>
  ),
};

interface Student {
  id: number;
  user_name: string;
  user_email: string;
  user_role?: string;
}

interface Enrollment {
  id: number;
  user: number;
  user_name: string;
  user_email: string;
  technology: string;
  status: string;
  progress_percentage: number;
  started_at: string | null;
  completed_at: string | null;
  created_at: string;
  service_name: string;
  progress_details?: any[];
}

const StudentProgressTracker: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [enrollments, setEnrollments] = useState<Enrollment[]>([]);
  const [filteredEnrollments, setFilteredEnrollments] = useState<Enrollment[]>([]);
  const [selectedStudent, setSelectedStudent] = useState<Enrollment | null>(null);
  const [showStudentModal, setShowStudentModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [technologyFilter, setTechnologyFilter] = useState('all');
  const [technologies, setTechnologies] = useState<string[]>([]);
  const [stats, setStats] = useState({
    totalStudents: 0,
    totalEnrollments: 0,
    avgProgress: 0,
    completedCount: 0,
    inProgressCount: 0,
    notStartedCount: 0,
  });

  useEffect(() => {
    fetchEnrollments();
  }, []);

  useEffect(() => {
    filterEnrollments();
  }, [searchTerm, statusFilter, technologyFilter, enrollments]);

  const fetchEnrollments = async () => {
    try {
      setLoading(true);
      const response = await adminTrainingAPI.getAllEnrollments();
      setEnrollments(response.data);
      setFilteredEnrollments(response.data);
      
      const uniqueTechs = Array.from(new Set(response.data.map((e: Enrollment) => e.technology))) as string[];
      setTechnologies(uniqueTechs);
      
      const totalEnrollments = response.data.length;
      const totalProgress = response.data.reduce((sum: number, e: Enrollment) => sum + e.progress_percentage, 0);
      const avgProgress = totalEnrollments > 0 ? Math.round(totalProgress / totalEnrollments) : 0;
      const completedCount = response.data.filter((e: Enrollment) => e.status === 'completed').length;
      const inProgressCount = response.data.filter((e: Enrollment) => e.status === 'in_progress').length;
      const notStartedCount = response.data.filter((e: Enrollment) => e.status === 'not_started').length;
      const totalStudents = Array.from(new Set(response.data.map((e: Enrollment) => e.user))).length;
      
      setStats({
        totalStudents,
        totalEnrollments,
        avgProgress,
        completedCount,
        inProgressCount,
        notStartedCount,
      });
    } catch (error) {
      console.error('Error fetching enrollments:', error);
    } finally {
      setLoading(false);
    }
  };

  const filterEnrollments = () => {
    let filtered = [...enrollments];
    
    if (searchTerm) {
      filtered = filtered.filter(e => 
        e.user_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        e.user_email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        e.technology?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    if (statusFilter !== 'all') {
      filtered = filtered.filter(e => e.status === statusFilter);
    }
    
    if (technologyFilter !== 'all') {
      filtered = filtered.filter(e => e.technology === technologyFilter);
    }
    
    setFilteredEnrollments(filtered);
  };

  const getStatusColor = (status: string) => {
    switch(status) {
      case 'completed': return '#10b981';
      case 'in_progress': return '#0ea5e9';
      default: return '#f59e0b';
    }
  };

  const getStatusBackground = (status: string) => {
    switch(status) {
      case 'completed': return '#d1fae5';
      case 'in_progress': return '#dbeafe';
      default: return '#fef3c7';
    }
  };

  const getStatusText = (status: string) => {
    switch(status) {
      case 'completed': return 'Completed';
      case 'in_progress': return 'In Progress';
      default: return 'Not Started';
    }
  };

  const getProgressColor = (percentage: number) => {
    if (percentage >= 80) return '#10b981';
    if (percentage >= 50) return '#f59e0b';
    return '#ef4444';
  };

  const formatDate = (dateString: string | null) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const handleViewStudentDetails = (enrollment: Enrollment) => {
    setSelectedStudent(enrollment);
    setShowStudentModal(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setShowStudentModal(false);
    setSelectedStudent(null);
    document.body.style.overflow = 'auto';
  };

  const exportToCSV = () => {
    const headers = ['Student Name', 'Email', 'Technology', 'Progress', 'Status', 'Started', 'Completed', 'Service'];
    const rows = filteredEnrollments.map(e => [
      e.user_name,
      e.user_email,
      e.technology,
      `${e.progress_percentage}%`,
      getStatusText(e.status),
      formatDate(e.started_at),
      formatDate(e.completed_at),
      e.service_name
    ]);
    
    const csvContent = [headers, ...rows].map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `student-progress-${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  if (loading) {
    return (
      <div className="spt-loading-container">
        <div className="spt-spinner">
          <Icons.Spinner />
        </div>
        <p className="spt-loading-text">Loading student progress data...</p>
      </div>
    );
  }

  return (
    <div className="spt-container">
      {/* Header */}
      <div className="spt-header">
        <div className="spt-header-left">
          <h1 className="spt-title">
            <Icons.GradCap />
            Student Progress Tracker
          </h1>
          <p className="spt-subtitle">Monitor and track student learning progress across all training programs</p>
        </div>
      </div>

      {/* Stats Bar */}
      <div className="spt-stats-bar">
        <div className="spt-stat-item">
          <span className="spt-stat-label">Total Students</span>
          <span className="spt-stat-value">{stats.totalStudents}</span>
        </div>
        <div className="spt-stat-divider"></div>
        <div className="spt-stat-item">
          <span className="spt-stat-label">Enrollments</span>
          <span className="spt-stat-value">{stats.totalEnrollments}</span>
        </div>
        <div className="spt-stat-divider"></div>
        <div className="spt-stat-item">
          <span className="spt-stat-label">Avg Progress</span>
          <span className="spt-stat-value spt-stat-progress">{stats.avgProgress}%</span>
        </div>
        <div className="spt-stat-divider"></div>
        <div className="spt-stat-item">
          <span className="spt-stat-label">Completed</span>
          <span className="spt-stat-value spt-stat-completed">{stats.completedCount}</span>
        </div>
        <div className="spt-stat-divider"></div>
        <div className="spt-stat-item">
          <span className="spt-stat-label">In Progress</span>
          <span className="spt-stat-value spt-stat-progress">{stats.inProgressCount}</span>
        </div>
        <div className="spt-stat-divider"></div>
        <div className="spt-stat-item">
          <span className="spt-stat-label">Not Started</span>
          <span className="spt-stat-value spt-stat-notstarted">{stats.notStartedCount}</span>
        </div>
      </div>

      {/* Filters */}
      <div className="spt-filters">
        <div className="spt-search">
          <Icons.Search />
          <input
            type="text"
            placeholder="Search by student name, email, or technology..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="spt-filter-group">
          <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="all">All Status</option>
            <option value="completed">Completed</option>
            <option value="in_progress">In Progress</option>
            <option value="not_started">Not Started</option>
          </select>
          <select value={technologyFilter} onChange={(e) => setTechnologyFilter(e.target.value)}>
            <option value="all">All Technologies</option>
            {technologies.map(tech => (
              <option key={tech} value={tech}>{tech}</option>
            ))}
          </select>
          <button className="spt-export-btn" onClick={exportToCSV}>
            <Icons.Export />
            Export CSV
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="spt-table-wrapper">
        <table className="spt-table">
          <thead>
            <tr>
              <th className="spt-col-student">Student</th>
              <th className="spt-col-tech">Technology</th>
              <th className="spt-col-progress">Progress</th>
              <th className="spt-col-status">Status</th>
              <th className="spt-col-started">Started</th>
              <th className="spt-col-completed">Completed</th>
              <th className="spt-col-actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredEnrollments.length === 0 ? (
              <tr>
                <td colSpan={7} className="spt-empty-state">
                  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                  <p className="spt-empty-text">No enrollment records found</p>
                </td>
              </tr>
            ) : (
              filteredEnrollments.map((enrollment) => (
                <tr key={enrollment.id} className="spt-table-row">
                  <td className="spt-col-student">
                    <div className="spt-student-info">
                      <div className="spt-student-avatar">
                        {enrollment.user_name?.charAt(0) || 'S'}
                      </div>
                      <div>
                        <div className="spt-student-name">{enrollment.user_name || 'N/A'}</div>
                        <div className="spt-student-email">{enrollment.user_email}</div>
                      </div>
                    </div>
                  </td>
                  <td className="spt-col-tech">
                    <span className="spt-tech-badge">{enrollment.technology}</span>
                  </td>
                  <td className="spt-col-progress">
                    <div className="spt-progress-wrapper">
                      <div className="spt-progress-bar">
                        <div 
                          className="spt-progress-fill"
                          style={{ 
                            width: `${enrollment.progress_percentage}%`,
                            background: getProgressColor(enrollment.progress_percentage)
                          }}
                        />
                      </div>
                      <span className="spt-progress-value">{enrollment.progress_percentage}%</span>
                    </div>
                  </td>
                  <td className="spt-col-status">
                    <span 
                      className="spt-status-badge"
                      style={{
                        background: getStatusBackground(enrollment.status),
                        color: getStatusColor(enrollment.status)
                      }}
                    >
                      <Icons.StatusDot />
                      {getStatusText(enrollment.status)}
                    </span>
                  </td>
                  <td className="spt-col-started">
                    <span className="spt-date-text">
                      <Icons.Calendar />
                      {formatDate(enrollment.started_at)}
                    </span>
                  </td>
                  <td className="spt-col-completed">
                    <span className="spt-date-text">
                      <Icons.Calendar />
                      {formatDate(enrollment.completed_at)}
                    </span>
                  </td>
                  <td className="spt-col-actions">
                    <button 
                      className="spt-action-btn"
                      onClick={() => handleViewStudentDetails(enrollment)}
                    >
                      <Icons.View />
                      View
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Student Details Modal */}
      {showStudentModal && selectedStudent && (
        <div className="spt-modal-overlay" onClick={closeModal}>
          <div className="spt-modal" onClick={(e) => e.stopPropagation()}>
            <div className="spt-modal-header">
              <h2 className="spt-modal-title">Student Progress Details</h2>
              <button className="spt-modal-close" onClick={closeModal}>
                <Icons.Close />
              </button>
            </div>
            <div className="spt-modal-body">
              <div className="spt-student-profile">
                <div className="spt-student-avatar-large">
                  {selectedStudent.user_name?.charAt(0) || 'S'}
                </div>
                <div className="spt-student-details">
                  <h3>{selectedStudent.user_name || 'N/A'}</h3>
                  <p>{selectedStudent.user_email}</p>
                  <p className="spt-service-name">
                    Service: {selectedStudent.service_name}
                  </p>
                </div>
              </div>
              
              <div className="spt-progress-summary">
                <div className="spt-summary-item">
                  <span className="spt-summary-label">Technology</span>
                  <span className="spt-summary-value">{selectedStudent.technology}</span>
                </div>
                <div className="spt-summary-item">
                  <span className="spt-summary-label">Overall Progress</span>
                  <div className="spt-summary-progress">
                    <div className="spt-progress-bar spt-progress-bar-sm">
                      <div 
                        className="spt-progress-fill"
                        style={{ 
                          width: `${selectedStudent.progress_percentage}%`,
                          background: getProgressColor(selectedStudent.progress_percentage)
                        }}
                      />
                    </div>
                    <span>{selectedStudent.progress_percentage}%</span>
                  </div>
                </div>
                <div className="spt-summary-item">
                  <span className="spt-summary-label">Status</span>
                  <span 
                    className="spt-status-badge"
                    style={{
                      background: getStatusBackground(selectedStudent.status),
                      color: getStatusColor(selectedStudent.status)
                    }}
                  >
                    <Icons.StatusDot />
                    {getStatusText(selectedStudent.status)}
                  </span>
                </div>
                <div className="spt-summary-item">
                  <span className="spt-summary-label">Started</span>
                  <span className="spt-summary-value">{formatDate(selectedStudent.started_at)}</span>
                </div>
                <div className="spt-summary-item">
                  <span className="spt-summary-label">Completed</span>
                  <span className="spt-summary-value">{formatDate(selectedStudent.completed_at)}</span>
                </div>
                <div className="spt-summary-item">
                  <span className="spt-summary-label">Enrolled</span>
                  <span className="spt-summary-value">{formatDate(selectedStudent.created_at)}</span>
                </div>
              </div>
            </div>
            <div className="spt-modal-footer">
              <button className="spt-close-btn" onClick={closeModal}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentProgressTracker;